import React, { FC, ReactNode } from 'react';

import Link from 'next/link';

import styles from './NewsCard.module.scss';

type Props = {
	href?: string;
	title: string;
	description: string | ReactNode;
};

export const NewsCard: FC<Props> = ({ title, description, href }) => {
	if (!href) {
		return (
			<div className={styles.newsCard}>
				<div className={styles.subtitle}>{title}</div>
				<div className={styles.description}>{description}</div>
			</div>
		);
	}

	return (
		<Link className={styles.newsCard} href={href} target="_blank" rel="noreferrer">
			<div className={styles.subtitle}>{title}</div>
			<div className={styles.description}>{description}</div>
		</Link>
	);
};
